import { render, staticRenderFns } from "./DashHeader.vue?vue&type=template&id=ff47c71c&scoped=true"
import script from "./DashHeader.vue?vue&type=script&lang=js"
export * from "./DashHeader.vue?vue&type=script&lang=js"
import style0 from "./DashHeader.vue?vue&type=style&index=0&id=ff47c71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff47c71c",
  null
  
)

export default component.exports